module.exports = __webpack_public_path__ + "static/media/clem-onojeghuo-2.bb4b9ac9.jpg";